import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TickList } from '../../Redux/action/tickList';
import moment from 'moment';
import axios from 'axios';
import $ from 'jquery';
import { dataUser } from '../Helpers/util';
import { toast } from 'react-toastify';
import axiosInstance from '../../utils/axiosInstance';
import VideoIcon from "./img/video-icon.svg";
import { OverlayTrigger, Popover } from 'react-bootstrap';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwButton from '../Common/SwButtons/SwButtons';
import AntDTable from '../Common/AntDTable/AntDTable';
import SwKpiGroup from '../Common/SwKPI/SwKpiGroup';
import SwKpi from '../Common/SwKPI/SwKPI';
import AntDUpload from '../Common/AntDUpload/AntDUpload';
import SwModal from '../Common/SwModal/SwModal';
import SwTooltip from '../Common/SwTooltip/SwTooltip';
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

class SnagTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCommentSection: false,
      showCommentModal: false,
      sendMessage: '',
      commentMessage: '',
      commentFiles: [], // Stores S3 keys
      commentFileNames: [],
      TicktingAllList: [],
      totleSeatData: '',
      closedSeatData: '',
      pendingSeatData: '',
      popupDetails: {},
      setIndex: 0,
      loader: false,
      ticketDetailsView: [],
      isModalOpen: false,
      rating: 0,
      feedback: '',
      files: [],
      UserEmail: UserObj?.email,
      isModalOpenFeedback: false,
      rateData: 0,
      isLoading: false,
      snagId: '',
      errorMessage: '',
      company_id: UserObj ? UserObj.company_id : null,
      pgno: 1,
      row: 25,
    };
  }

  handleRemoveFile = idx => {
    this.setState(prev => ({
      commentFiles: (prev.commentFiles || []).filter((_, i) => i !== idx),
      commentFileNames: (prev.commentFileNames || []).filter(
        (_, i) => i !== idx,
      ),
      fileInputKey: Date.now(),
    }));
  };

  // Keep handleCommentToggle as is
  handleCommentToggle = () => {
    this.setState(prevState => ({
      showCommentSection: !prevState.showCommentSection,
    }));
  };

  // Keep handleCommentChange as is
  handleCommentChange = e => {
    this.setState({ commentMessage: e.target.value });
  };

  // Update handleCommentSubmit to ensure files are sent correctly
  handleCommentSubmit = async () => {
    const { commentMessage, commentFiles, ticketId } = this.state;

    if (!commentMessage) {
      console.error('Comment message is required');
      return;
    }

    try {
      if (this.state.uploading) {
        await new Promise(resolve => {
          const checkUpload = setInterval(() => {
            if (!this.state.uploading) {
              clearInterval(checkUpload);
              resolve();
            }
          }, 100);
        });
      }

      const cleanedFiles = (commentFiles || []).map(url => {
        const parts = url.split('/');
        return parts.slice(-2).join('/'); // Ensure format is attachment/filename
      });

      const requestBody = {
        ticketId: ticketId,
        message: commentMessage,
        commentFile: cleanedFiles.length > 0 ? cleanedFiles : [], // Ensure array is sent even if empty
      };

      const response = await axiosInstance.put(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }tickets/v1/api/ticket/client/addcomment`,
        requestBody,
      );

      if (response.data.statusValue === 200) {
        toast.success(response.data.message);

        $('.close').click();
        // Reset fields
        this.setState({
          showCommentSection: false,
          commentMessage: '',
          commentFiles: [],
          commentFileNames: [],
          fileInputKey: Date.now(),
        });
      }
    } catch (error) {
      console.error(
        'Error submitting comment:',
        error.response?.data || error.message,
      );
    }
  };
  // Add uploadDocument method
  uploadDocument1 = async file => {
    if (!file) return null;

    this.setState({ uploading: true });

    try {
      const sanitizedFileName = encodeURIComponent(file.name.trim());
      const attachments = {
        bucket: 'ticketing-uat',
        key: `attachment/${sanitizedFileName}`,
      };

      const { data } = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}fileupload`,
        attachments,
      );

      const uploadUrl = data?.uploadUrl;
      if (!uploadUrl) throw new Error('Failed to get upload URL.');

      await axios.put(uploadUrl, file, {
        headers: { 'Content-Type': file.type || 'binary/octet-stream' },
      });

      const trimmedUrl = uploadUrl.split('?')[0];
      const s3Key = trimmedUrl.split('amazonaws.com/')[1];

      this.setState({ uploading: false });
      return { s3Key, fileName: file.name }; // Return both S3 key and file name
    } catch (error) {
      console.error('Error uploading file:', error);
      this.setState({ uploading: false });
      return null;
    }
  };

  // Update handleFileChange to upload files to S3
  handleFileChange = async e => {
    const files = Array.from(e.target.files);
    const uploadedUrls = [];
    const uploadedNames = [];

    for (let file of files) {
      const result = await this.uploadDocument1(file);
      if (result) {
        uploadedUrls.push(result.s3Key);
        uploadedNames.push(result.fileName);
      }
    }

    this.setState(prev => ({
      commentFiles: [...(prev.commentFiles || []), ...uploadedUrls],
      commentFileNames: [...(prev.commentFileNames || []), ...uploadedNames],
      fileInputKey: Date.now(),
    }));
  };

  openModal = (userEmail, snagId) => {
    this.setState({ isModalOpen: true, userEmail, snagId: snagId });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false, userEmail: '' });
  };

  openModalFeedback = () => {
    this.setState({ isModalOpenFeedback: true });
  };

  formatDueDate(dueDateString) {
    const dueDate = new Date(dueDateString);
    const now = new Date();
    const today = new Date(now.toDateString());
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    if (dueDate.toDateString() === today.toDateString()) {
      // Due today
      return `Due by ${dueDate.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      })}`;
    } else if (dueDate.toDateString() === tomorrow.toDateString()) {
      // Due tomorrow
      return 'Due by tomorrow';
    } else {
      // Due on some other day
      return `${dueDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
      })}`;
    }
  }

  closeModalFeedback = () => {
    this.setState({ isModalOpenFeedback: false, userEmail: '' });

    const { params } = this.props;
    // Make the API call
    this.props.TickList(params);
  };

  handleRating = ratingValue => {
    this.setState({
      rating: ratingValue,
      errorMessage: ratingValue === 0 ? 'Please provide a rating.' : '',
    });
  };

  // handleFileChange = (e) => {
  //   this.setState({ files: e.target.files });
  // };

  handleFileChange = e => {
    const files = Array.from(e.target.files);
    this.setState({ files });
  };

  handleRemoveFile = index => {
    const { files } = this.state;
    files.splice(index, 1);
    this.setState({ files });
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async e => {
    e.preventDefault();
    if (this.state.rating === 0) {
      this.setState({ errorMessage: 'Please provide a rating.' });
      return;
    }

    const { rating, feedback, files, UserEmail } = this.state;
    const formData = new FormData();
    formData.append('rating', rating);
    formData.append('feedback', feedback);
    formData.append('email', UserEmail);

    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i]);
    }

    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v2/tickets/feedback/${this.state.ticketId}`,
        formData,
      );

      if (response.data.statusText == 'SUCCESS') {
        //   toast.success('Thank You for your feedback and rating', {
        //
        // });

        this.setState({ isModalOpenFeedback: true });
        this.setState({ isModalOpen: false });
        this.setState({ rating: 0 });
        this.setState({ feedback: '' });
        this.setState({
          files: [],
          errorMessage: '',
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  changeforward = () => {
    var itemIndex = this.state.TicktingAllList[this.state.setIndex + 1];
    var singleId = itemIndex;
    this.setState({
      setIndex: this.state.setIndex + 1,
      popupDetails: singleId,
      loader: true,
    });
    setTimeout(() => {
      this.setState({
        loader: false,
      });
    }, 1000);
  };

  changebackformward = () => {
    var itemIndex = this.state.TicktingAllList[this.state.setIndex - 1];
    var singleId = itemIndex;

    this.setState({
      setIndex: this.state.setIndex - 1,
      popupDetails: singleId,
      loader: true,
    });
    setTimeout(() => {
      this.setState({
        loader: false,
      });
    }, 1000);
  };
  sendId = async (items, i, items1) => {
    this.setState({ rateData: items1 });
    this.setState({ sendMessage: items.Status });
    let uniqueId = items.ticketUniqueId;
    this.setState({ snagId: uniqueId });

    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }tickets/v1/api/ticket/clientv2/${uniqueId}`,
      );

      if (response?.data?.statusValue === 200) {
        this.setState({ ticketDetailsView: response?.data?.data, setIndex: i });
      }
    } catch (e) {
      console.error(e);
    }
  };
  getMimeType = attachment => {
    if (attachment.endsWith('.pdf')) {
      return 'application/pdf';
    } else if (attachment.endsWith('.docx')) {
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    } else {
      return 'image/jpeg'; // Default to an image type
    }
  };

  getMimeType1 = attachment => {
    const ext = attachment
      .split('.')
      .pop()
      .toLowerCase();
    if (ext === 'pdf') {
      return 'application/pdf';
    } else if (ext === 'docx') {
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    } else if (['mp4', 'webm', 'ogg', 'mov'].includes(ext)) {
      return 'video';
    } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'].includes(ext)) {
      return 'image';
    } else {
      return 'unknown'; // fallback for unsupported or unknown types
    }
  };
  openViewer = url => {
    window.open(url, '_blank');
  };
  openViewer1 = url => {
    window.open(url, '_blank');
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.ticketReducer !== prevProps.ticketReducer &&
      this.props.ticketReducer?.TicketAllList?.status === 200
    ) {
      const { list = [], total = 0, closed = 0, pending = 0 } =
        this.props.ticketReducer?.TicketAllList?.data || {};

      this.setState({
        TicktingAllList: list,
        totleSeatData: total,
        closedSeatData: closed,
        pendingSeatData: pending,
        isLoading: false, // Stop loading when data is set
      });
    }
  }


  render() {
    const isUserAllowed =
      this.state.ticketDetailsView.userInfo?.email === this.state.UserEmail;
    const {
      showCommentSection,
      commentFileNames,
      commentMessage,
      UserObj,
    } = this.state;
    const { ticketDetailsView } = this.state;
    const dueDateFormatted = ticketDetailsView?.dueDate
      ? this.formatDueDate(ticketDetailsView.dueDate)
      : '';
    const columns = [
      {
        title: "Snag No",
        dataIndex: "requestId",
        render: (_, record, index) => (
          <span
            className="SwLinkInfo HoverUnderline"
            role='button'
            onClick={() => {
              this.sendId(record, index, record.rating);
              this.setState({ showTicketDetails: true });
            }}
          >
            {record.requestId}
          </span>
        ),
      },
      {
        title: "Project Name",
        dataIndex: ["formInfo", "projectName"],
      },
      {
        title: "Subcategory",
        dataIndex: "subCategory",
      },
      {
        title: "Subject",
        dataIndex: "Subject",
      },
      {
        title: "Location",
        dataIndex: "Location",
      },
      {
        title: "Created At",
        dataIndex: "createdTime",
        render: (v) => moment(v).format("DD MMM YYYY"),
      },
      {
        title: "Closed",
        dataIndex: "ticketCloseTime",
        render: (v) =>
          !v || v === "0000-00-00 00:00:00"
            ? "--"
            : moment(v).format("DD MMM YYYY"),
      },
      {
        title: "Raised By",
        dataIndex: "contactName",
      },
      {
        title: "Status",
        dataIndex: "Status",
        render: (v) =>
          v === "Closed" ? (
            <span className="text-success">{v}</span>
          ) : (
            <span className="SwTextDanger SwTextSmall">{v}</span>
          ),
      },
      {
        title: "Feedback",
        dataIndex: "rating",
        render: (v, record) =>
          v === "" ? (
            "-"
          ) : v === 0 ? (
            <a
              onClick={(e) => {
                e.stopPropagation();
                this.openModal(this.state.UserEmail, record.ticketUniqueId);
              }}
            >
              Rate
            </a>
          ) : (
            <span>
              {v} <img src="img/star.svg" alt="star" />
            </span>
          ),
      },
      {
        title: "",
        render: (_, record, index) => (
          <i
            className="fa fa-eye SwSortableTh"
            onClick={() => {
              this.sendId(record, index, record.rating);
              this.setState({ showTicketDetails: true });
            }}
          />
        ),
      },
    ];

    return (
      <>
        <SwOffCanvas
          show={this.state.showTicketDetails}
          onHide={() => this.setState({ showTicketDetails: false })}
          title="Snag Details"
          footer={
            <>
              {this.state.rateData > 0 && (
                <div className="ml-auto ratedBtn">
                  <span>You rated</span>
                  <span>{this.state.rateData}</span>
                  <img src="img/star.svg" alt="star" />
                </div>
              )}

              {this.state.rateData == 0 && this.state.sendMessage === 'Closed' && isUserAllowed ? (

                <SwButton
                  size="sm"
                  onClick={() =>
                    this.openModal(
                      this.state.UserEmail,
                      this.state.ticketId,
                    )
                  }
                >
                  Share Feedback
                </SwButton>
              ) : (

                <div className="OffCanvasFooter_Btns">
                  {!isUserAllowed ? (
                    <SwTooltip
                      placement="top"
                      content={
                        <div>You can only send a message for tickets created by you.</div>
                      }
                    >
                      <span>
                        <SwButton
                          size="sm"
                          disabled
                          style={{ pointerEvents: 'none' }}
                        >
                          Send a message
                        </SwButton>
                      </span>
                    </SwTooltip>
                  ) : (
                    <SwButton
                      size="sm"
                      onClick={() => this.setState({ showCommentModal: true })}
                    >
                      Send a message
                    </SwButton>
                  )}
                </div>

              )}
            </>
          }
        >
          <div className="TicketModal">
            
              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <p className="SwTextGray mb-0">Snag Id</p>
                    <p>{this.state?.ticketDetailsView?.ticketNumber}</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <p className="SwTextGray mb-0">Snag Status</p>
                    <p>
                      {this.state?.ticketDetailsView?.clientStatus ==
                        'Closed' ? (
                        <div className="SwTextSuccess">
                          {this.state?.ticketDetailsView?.clientStatus}
                        </div>
                      ) : (
                        <div className="SwTextDanger">
                          {this.state.ticketDetailsView.clientStatus}
                        </div>
                      )}
                    </p>
                  </div>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <p className="SwTextGray mb-0">Raised by</p>
                    <p>{this.state.ticketDetailsView?.userInfo?.name}</p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <p className="SwTextGray mb-0">Created time</p>
                    <p>
                      {this.state.ticketDetailsView.createdAt ===
                        '0000-00-00 00:00:00'
                        ? '--'
                        : moment
                          .utc(this.state.ticketDetailsView.createdAt)
                          .add(5, 'hours')
                          .add(30, 'minutes')
                          .format('DD MMM YYYY - h:mm:ss a')}
                    </p>
                  </div>
                </div>

                
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <p className="SwTextGray mb-0">Category</p>
                    <p>{this.state.ticketDetailsView.category}</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <p className="SwTextGray mb-0">Sub Category</p>
                    <p>{this.state.ticketDetailsView.subCategory}</p>
                  </div>
                </div>
              </div>


              {[2021, 2073].includes(UserObj?.company_id) ? (
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="SwFormGroup">
                      <p className="SwTextGray mb-0">Due By </p>
                      <p>{dueDateFormatted}</p>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}

              


              <div className="row mb-3">
                <div className="col-md-12">
                  {this.state.ticketDetailsView.actionTimeline &&
                    this.state.ticketDetailsView.actionTimeline.map(
                      (item, index) => (
                        <div
                          className="TicketModalSection"
                          key={index}
                        >
                          {/* Avatar and Header Info */}
                          <div
                            className="TicketModal_AvatarSection"
                          >
                            <div
                              className="UserAvatar"
                              style={{ backgroundColor: item.background, }}
                            >
                              {item.nameInitials}
                            </div>
                            <div className='TicketUserInfo'>
                              {/* <strong>{item.fullName}</strong>{' '} */}
                              <div>{item.action}</div>
                              <div className='TicketUpdateTime'>
                                {new Date(item.createdAt).toLocaleString(
                                  'en-IN',
                                  {
                                    hour: 'numeric',
                                    minute: 'numeric',
                                    second: 'numeric',
                                    hour12: true,
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                  },
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Description */}
                          {index === 0 && item.subject && (
                            <div className="TicketSubject">
                              {item.subject}
                            </div>
                          )}
                          <div className="TicketDescription">
                            <p>{item.description || '--'}</p>
                          </div>


                          {/* Attachments (updated like userAttachments) */}
                          {item.attachments &&
                            item.attachments.length > 0 ? (
                            <div className="mb-2">

                              <div className="d-flex flex-wrap">
                                {item.attachments.map((url, i) => (
                                  <div
                                    key={`timeline-attachment-${i}`}
                                    className="AttachedFileBox"
                                  >
                                    <div className="AttachedFileView">
                                      {this.getMimeType1(url) ===
                                        'application/pdf' ? (
                                        <img
                                          src="img/pdf-file-icon.svg"
                                          alt="Attachment"
                                          onClick={() =>
                                            this.openViewer1(url)
                                          }
                                        />
                                      ) : this.getMimeType1(url) ===
                                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? (
                                        <iframe
                                          src={`https://docs.google.com/viewer?url=${url}&embedded=true`}
                                          title="DOCX Attachment"
                                          onClick={() =>
                                            this.openViewer1(url)
                                          }
                                        />
                                      ) : this.getMimeType1(url) ===
                                        'video' ? (
                                        <img
                                          src={VideoIcon}
                                          className='FileIcon'
                                          alt="Video File"
                                          onClick={() => window.open(url, '_blank')}
                                        />
                                      ) : (
                                        <img
                                          src={url}
                                          alt="Attachment nn"
                                          onClick={() =>
                                            this.openViewer1(url)
                                          }
                                        />
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : ("")}
                        </div>
                      ),
                    )}
                </div>
              </div>

            
          </div>
          <SwModal
            show={this.state.showCommentModal}
            onClose={() =>
              this.setState({
                showCommentModal: false,
                uploadList: [],
                commentMessage: '',
              })
            }
            title="Please enter your message"
            className="sw-default-modal"
            backdrop="static"
            keyboard={false}
            footer={
              <>
                <SwButton
                  size="sm"
                  variant="dark-outline"
                  onClick={() =>
                    this.setState({
                      showCommentModal: false,
                      commentMessage: '',
                      commentFileNames: '',
                      uploadList: [],
                    })
                  }
                >
                  Cancel
                </SwButton>

                <SwButton
                  size="sm"
                  variant="dark"
                  onClick={() => {
                    this.handleCommentSubmit();
                    this.setState({
                      showCommentModal: false,
                      uploadList: [],
                      commentMessage: '',
                    });
                  }}
                  disabled={this.state.uploading}
                >
                  Submit
                </SwButton>
              </>
            }
          >
            <div className="SendMsgModal_content">
              <div className="SendMsg_row">
                <SwTextArea
                  ref={this.inputRef}
                  value={commentMessage}
                  onChange={this.handleCommentChange}
                  placeholder="Type your message here..."
                  rows={8}
                />
              </div>

              <div className="row mb-4">
                <div className="col-md-8">
                  <AntDUpload
                    type="button"
                    listType="text"
                    multiple
                    autoUpload={false}
                    fileList={this.state.uploadList}
                    disabled={this.state.uploading}
                    onChange={({ fileList }) => {
                      this.setState({ uploadList: fileList }, async () => {
                        for (let fileObj of fileList) {
                          if (!fileObj.uploaded) {
                            const result = await this.uploadDocument1(
                              fileObj.originFileObj
                            );

                            if (result) {
                              this.setState(prev => ({
                                commentFiles: [
                                  ...(prev.commentFiles || []),
                                  result.s3Key,
                                ],
                                commentFileNames: [
                                  ...(prev.commentFileNames || []),
                                  result.fileName,
                                ],
                              }));

                              fileObj.uploaded = true;
                            }
                          }
                        }
                      });
                    }}
                  >
                    <SwButton
                      variant="primary"
                      icon={<i className="bi bi-upload"></i>}
                    >
                      Upload Documents
                    </SwButton>
                  </AntDUpload>
                </div>
              </div>
            </div>
          </SwModal>
        </SwOffCanvas>
        <div className='row'>
          <div className='col-12'>
            <SwKpiGroup>
              <SwKpi
                label='Total Snag'
                value={this.state.totleSeatData}
              />
              <SwKpi
                label='Resolved'
                value={this.state.closedSeatData}
              />
              <SwKpi
                label='Pending'
                value={this.state.pendingSeatData}
              />
            </SwKpiGroup>
          </div>
        </div>
        <AntDTable
          rowKey="ticketUniqueId"
          columns={columns}
          dataSource={this.state.TicktingAllList}
          loading={this.state.isLoading}
          pagination={true}
          pageSize={this.props.pageSize}
          currentPage={this.props.currentPage}
          totalRecords={this.props.totalRecords}
          onPageChange={this.props.onPageChange}
          clientSideSorting={false}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  ticketReducer: state.ticketReducer,
  visitorReducer: state.visitorReducer,
});

const mapActionsToProps = {
  TickList,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(SnagTable);
